export default "__VITE_ASSET__BfM0QyWB__"